import { proxy } from 'valtio';

import { Defaults } from 'utils/defaults';

const themeStore = proxy({
 mode: Defaults.themeMode,
});

export default themeStore;
